import ClaimsService from "@/api/services/claims";

const initialState = {};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isPaid: () => (finalSettlement) => {
      return finalSettlement?.status === "payment_done";
    },
    statusClass: () => (finalSettlement) => {
      switch (finalSettlement?.status) {
        case "payment_done":
          return "bg-green-200 text-green-800";
        case "pending_payment":
          return "bg-yellow-200 text-yellow-800";
        default:
          return "bg-gray-200 text-gray-600";
      }
    },
  },
  mutations: {},
  actions: {
    async fetchInvoiceUrl(_, { id }) {
      const response = await ClaimsService.fetchFinalSettlementInvoiceUrl(id);
      if (!response?.success) return;

      return response;
    },
  },
};
